<template lang="pug">
.row
  .column
    .simple_form.edit_user(novalidate="novalidate")
      input(name="utf8" type="hidden" value="✓")
      input(type="hidden" name="_method" value="patch")
      .c-linear-form
        .input.select.required.user_status.c-linear-form__field
          select#user_status.select.required.c-linear-form__input.c-linear-form__input--select(data-purpose="user_detail_status"  name="user[status]" v-model="professionalStatus")
            option(v-for="option in userDetailsStatuses" :value="option.value" :disabled="option.disabled" :selected="option.selected")
              | {{option.text}}
        .input.string.required.user_birthdate.c-linear-form__field
          input#user_birthdate.string.required.c-linear-form__input(data-purpose="user_birthdate" :placeholder="$t('landingPage.form.date_placeholder')" onfocus="(this.type='date')" ontouchstart="(this.type='date')" type="text" v-model="birthdate")
        .input.select.required.user_civil_state.c-linear-form__field
          select.select.required.c-linear-form__input.c-linear-form__input--select(data-purpose="user_detail_civil_state"  name="user[status]" id="user_status" v-model="civilStatus")
            option(v-for="option in userCivilStates" :value="option.value" :disabled="option.disabled" :selected="option.selected")
              | {{option.text}}
        input#checkupSubmit.button.success.c-linear-form__button(type="submit" name="commit" :value="$t('landingPage.form.button')" data-purpose="start_checkup_button" @click="submitForm")
      #missingFieldsMessage.row.text-center(v-if="displayMissingFieldsMessage")
        .columns.small-12
          .p-error {{$t('landingPage.form.error.missing_fields')}}
      #tooYoungMessage.row.text-center(v-if="displayTooYoungMessage")
        .columns.small-12
          .p-error {{$t('landingPage.form.error.too_young')}}
      p.p-credits(v-html="$t('landingPage.form.credits')")
</template>

<script>
export default {
  data () {
    return {
      displayMissingFieldsMessage: false,
      displayTooYoungMessage: false,
      userDetailsStatuses: [
        {text: 'Mon statut', value: null, disabled: true, selected: true},
        {text: 'Employé', value: 'employee'},
        {text: 'Indépendant', value: 'independent'},
        {text: 'Fonctionnaire', value: 'state_employee'},
        {text: 'Ouvrier', value: 'workman'},
        {text: 'Retraité', value: 'retired'},
        {text: 'Sans profession', value: 'unemployed'}
      ],
      userCivilStates: [
        {text: 'Etat civil', value: null, disabled: true, selected: true},
        {text: 'Célibataire', value: 'single'},
        {text: 'Veuf', value: 'widower'},
        {text: 'Divorcé(e)', value: 'divorced'},
        {text: 'Marié(e)', value: 'married'},
        {text: 'Cohabitant', value: 'cohabitant'}
      ]
    }
  },
  computed: {
    professionalStatus: {
      get () {
        return this.$store.state.person.professional_status
      },
      set (value) {
        this.$store.commit('updatePersonInfo', {name: 'professional_status', value: value})
      }
    },
    birthdate: {
      get () {
        return this.$store.state.person.birthdate
      },
      set (value) {
        this.$store.commit('updatePersonInfo', {name: 'birthdate', value: value})
      }
    },
    civilStatus: {
      get () {
        return this.$store.state.person.civil_status
      },
      set (value) {
        this.$store.commit('updatePersonInfo', {name: 'civil_status', value: value})
      }
    },
    missingFields () {
      return !this.professionalStatus || !this.birthdate || !this.civilStatus
    },
    tooYoung () {
      return this.$store.getters.getAge < 18
    }
  },
  methods: {
    submitForm () {
      this.displayMissingFieldsMessage = this.missingFields
      this.displayTooYoungMessage = this.tooYoung

      if (!this.missingFields && !this.displayTooYoungMessage) {
        this.$router.push('profiles')
      }
    }
  }

}
</script>



// WEBPACK FOOTER //
// src/components/landingPage/Form.vue